/* he-mobile-scripts.js · 2026-06-15
   ─────────────────────────────────────────────────────────────
   Sync <details class="he-accordion"> open-state with viewport.
   CSS cannot toggle the `open` HTML attribute, and the browser's
   UA stylesheet hides non-summary children of closed <details> at
   the spec level — defeating every CSS force-open approach we
   tried. JS sets the attribute directly: open on desktop, closed
   on mobile. Runs on DOM-ready and on breakpoint change.
   ───────────────────────────────────────────────────────────── */
(function () {
  function syncHEAccordions() {
    var isDesktop = window.matchMedia('(min-width: 750px)').matches;
    document.querySelectorAll('details.he-accordion').forEach(function (el) {
      el.open = isDesktop;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncHEAccordions);
  } else {
    syncHEAccordions();
  }
  var mql = window.matchMedia('(min-width: 750px)');
  if (mql.addEventListener) {
    mql.addEventListener('change', syncHEAccordions);
  } else if (mql.addListener) {
    mql.addListener(syncHEAccordions);
  }
})();

/* PDP-GALLERY-CAROUSEL (2026-06-17) · dot pagination + tap-to-scroll
   for the mobile-only swipe carousel. CSS in he-mobile-foundation.css
   converts .pdp-gallery__main to a scroll-snap rail showing all 7
   .pdp-gallery__media slides side by side; this script adds the
   indicator dots beneath the rail and wires click-to-scroll on each
   dot. Mobile-only via matchMedia('(max-width: 749px)') so desktop
   users never see the dots (the gallery's own thumbnail strip is
   the desktop affordance). Idempotent — re-runs on breakpoint flip
   create / tear down the dots so the experience stays correct when
   the viewport crosses 749px. */
(function () {
  /* 2026-06-17 · rev2 (per operator screenshot):
     · ACTIVE/IDLE both dark — IDLE = ink @ 25% so all dots read as
       dark on the paper bg (was IDLE='#C8C4B8' paper-mid which only
       worked on the dark frame bg).
     · Dots now inserted OUTSIDE the .pdp-gallery-frame (after the
       frame, not as a sibling of .pdp-gallery__main). The frame
       carries the Tee/Print/Complete dark bg from snippets/pdp-
       gallery.liquid:191 — placing the dots inside it surfaced as
       a black band beneath the image. Moving them out drops them
       onto the page's paper bg, matching the rest of the PDP body. */
  /* 2026-09-19 · addendum 3 · the dots move ONTO the image.
     Sitting below the frame they cost 36px of vertical space, and on Space
     products they were painted #0A0A0A on a #0A0A0A page background — 1.00:1,
     invisible on 12 of the 54 active products. Absolutely positioned inside
     the frame they never touch the page background, so no world palette can
     erase them, and the hardcoded page-background colours below are gone.

     Fill and ring are deliberately paired rather than either alone: measured
     on mount-st-helens-print, a white fill reads 12.7:1 on the dark-room shot
     but only 1.27–1.41:1 on the two light flat scans, while a thin ring is
     ~1.8:1 on those. White fill + a 55% black ring measures 3.54–3.74:1 on the
     light slides and keeps 12.7:1 on the dark one — both clear the 3:1 that
     WCAG 1.4.11 asks of a UI component boundary. */
  var ACTIVE = '#fff';
  var IDLE = 'rgba(255, 255, 255, 0.45)';
  var DOT_RING = 'box-shadow:0 0 0 1px rgba(0, 0, 0, 0.55), 0 1px 3px rgba(0, 0, 0, 0.45);';

  function findFrame(wrap) {
    // .pdp-gallery__main lives inside .pdp-gallery-frame
    var f = wrap.parentNode;
    while (f && !(f.classList && f.classList.contains('pdp-gallery-frame'))) {
      f = f.parentNode;
    }
    return f || wrap.parentNode;
  }

  /* addendum 3 · the dots are now a child of the frame, so both the build
     guard and the teardown have to look there. Left pointing at the frame's
     parent, findDots would return null once the dots moved: buildDots would
     append a fresh row on every syncPDPCarousel call, and tearDownDots would
     silently do nothing, leaving the dots on desktop where they must not be. */
  function findDots(frame) {
    return frame.querySelector(':scope > .pdp-gallery__dots');
  }

  function buildDots(wrap) {
    var frame = findFrame(wrap);
    if (findDots(frame)) return;
    var slides = Array.from(wrap.querySelectorAll('.pdp-gallery__media'));
    if (slides.length <= 1) return;

    var dotWrap = document.createElement('div');
    dotWrap.className = 'pdp-gallery__dots';
    dotWrap.style.cssText = 'position:absolute;left:0;right:0;bottom:14px;' +
      'display:flex;justify-content:center;gap:7px;background:transparent;pointer-events:auto;';

    slides.forEach(function (_, i) {
      var d = document.createElement('span');
      d.style.cssText = 'width:7px;height:7px;border-radius:50%;background:' +
        (i === 0 ? ACTIVE : IDLE) + ';' + DOT_RING + 'transition:background .2s;cursor:pointer;';
      d.dataset.idx = i;
      dotWrap.appendChild(d);
    });

    // addendum 3 · inside the frame, over the image. .pdp-gallery-frame
    // already computes position:relative, so it is the containing block and
    // nothing else has to change.
    frame.appendChild(dotWrap);

    // 2026-10-03 · v2 · the step is the slide plus the gap, not the width of
    // the track. With the peek the two are no longer the same: dividing by
    // wrap.offsetWidth put the active dot on the wrong slide from slide 2 on,
    // and the dot clicks scrolled short by the gap each time.
    function step() {
      var first = slides[0];
      if (!first) return wrap.offsetWidth;
      var gap = parseFloat(getComputedStyle(wrap).columnGap || getComputedStyle(wrap).gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function index() {
      var st = step();
      return st ? Math.round(wrap.scrollLeft / st) : 0;
    }

    // §2.4 · past eight images the dots are wider than the screen, so the
    // counter carries the position on its own.
    if (slides.length > 8) dotWrap.setAttribute('data-many', 'true');

    function onScroll() {
      var idx = index();
      dotWrap.querySelectorAll('span').forEach(function (d, i) {
        d.style.background = i === idx ? ACTIVE : IDLE;
      });
      syncCounter(wrap, idx, slides.length);
      syncArrows(wrap, idx, slides.length);
    }
    wrap.addEventListener('scroll', onScroll, { passive: true });

    dotWrap.querySelectorAll('span').forEach(function (d) {
      d.addEventListener('click', function () {
        wrap.scrollTo({
          left: parseInt(d.dataset.idx, 10) * step(),
          behavior: 'smooth',
        });
      });
    });

    wireArrows(wrap, slides.length, step);
    syncCounter(wrap, 0, slides.length);
    syncArrows(wrap, 0, slides.length);
  }

  /* ── v2 §3 route A · the counter ───────────────────────────────────────
     The element is already in the markup (product.media.size > 1) and was
     hidden on mobile along with the thumbnail strip. It is moved into the
     frame so it can be positioned over the top of the slide — the same move
     the dots got in addendum 3 — and its number follows the scroll, which
     nothing was doing on mobile before. */
  function findCounter(wrap) {
    var frame = findFrame(wrap);
    if (!frame) return null;
    var inside = frame.querySelector(':scope > .pdp-gallery__counter');
    if (inside) return inside;
    var outside = frame.parentNode && frame.parentNode.querySelector('.pdp-gallery__counter');
    if (outside) { frame.appendChild(outside); return outside; }
    return null;
  }

  function syncCounter(wrap, idx, total) {
    var counter = findCounter(wrap);
    if (!counter) return;
    var cur = counter.querySelector('[data-pdp-gallery-counter-current]');
    var tot = counter.querySelector('[data-pdp-gallery-counter-total]');
    if (cur) cur.textContent = String(Math.min(Math.max(idx + 1, 1), total));
    if (tot) tot.textContent = String(total);
  }

  /* ── v2 §2.3 · the arrows ──────────────────────────────────────────────
     Markup added to the product.media branch of snippets/pdp-gallery.liquid;
     the pair that already existed renders only on the v6-slot path. A tap
     moves exactly one slide, and each arrow disappears at the end it would
     take you past. */
  function arrowsOf(wrap) {
    var frame = findFrame(wrap);
    if (!frame) return {};
    return {
      prev: frame.querySelector('[data-pdp-gallery-m-prev]'),
      next: frame.querySelector('[data-pdp-gallery-m-next]')
    };
  }

  function syncArrows(wrap, idx, total) {
    var a = arrowsOf(wrap);
    if (a.prev) a.prev.hidden = idx <= 0;
    if (a.next) a.next.hidden = idx >= total - 1;
  }

  function wireArrows(wrap, total, step) {
    var a = arrowsOf(wrap);
    if (!a.prev && !a.next) return;
    if (wrap.__heArrowsWired) return;
    wrap.__heArrowsWired = true;
    function go(dir) {
      wrap.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    if (a.prev) a.prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    if (a.next) a.next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
  }

  function tearDownDots(wrap) {
    var frame = findFrame(wrap);
    var dots = findDots(frame);
    if (dots) dots.parentNode.removeChild(dots);
  }

  /* ── 2026-10-03 · video autoplay on mobile ─────────────────────────────
     The contract is CODE_TASK_VIDEO_3 v2.2: muted autoplay when the clip's
     slide becomes active, never on page load, one centred toggle that never
     auto-hides, pause and rewind on leave. pdp-gallery.js does all of that
     from show(), which only runs on a thumb click — and the thumbnail strip
     is hidden at <=749px, so on a phone show() never ran after load and the
     clip sat on its poster frame however far you scrolled.

     The scroll track is the trigger instead: a slide that is at least 60%
     visible inside the track is the active one. That covers swipes and the
     new arrows alike, since both move the same scroll position. On load a
     clip at position 3 is nowhere near 60% visible, so nothing plays until
     the visitor arrives — which is the "never on page load" half of the
     contract.

     The toggle is left alone: its glyph and aria-label are driven by the
     video's own play/pause events in pdp-gallery.js, so calling play() or
     pause() here keeps it in step with no extra wiring. */
  function wireVideoAutoplay(wrap) {
    if (wrap.__heVideoIO) return;
    if (typeof IntersectionObserver !== 'function') return;
    var slides = Array.from(wrap.querySelectorAll('.pdp-gallery__media'))
      .filter(function (s) { return s.querySelector('video'); });
    if (!slides.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var vid = en.target.querySelector('video');
        if (!vid) return;
        if (en.isIntersecting && en.intersectionRatio >= 0.6) {
          vid.muted = true;
          var pr = vid.play();
          if (pr && typeof pr.catch === 'function') pr.catch(function () {});
        } else if (!vid.paused) {
          vid.pause();
          try { vid.currentTime = 0; } catch (e) {}
        }
      });
    }, { root: wrap, threshold: [0, 0.6, 1] });

    slides.forEach(function (s) { io.observe(s); });
    wrap.__heVideoIO = io;
  }

  function tearDownVideoAutoplay(wrap) {
    if (!wrap.__heVideoIO) return;
    wrap.__heVideoIO.disconnect();
    wrap.__heVideoIO = null;
  }

  function syncPDPCarousel() {
    var wrap = document.querySelector('.pdp-gallery__main');
    if (!wrap) return;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) { buildDots(wrap); wireVideoAutoplay(wrap); }
    else { tearDownDots(wrap); tearDownVideoAutoplay(wrap); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPDPCarousel);
  } else {
    syncPDPCarousel();
  }
  var mql = window.matchMedia('(max-width: 749px)');
  if (mql.addEventListener) {
    mql.addEventListener('change', syncPDPCarousel);
  } else if (mql.addListener) {
    mql.addListener(syncPDPCarousel);
  }
})();
